var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['input-group', { disabled: _vm.disabled }, { error: _vm.error }]},[_c('label',{class:{
      'input-group__label': true,
      'input-group__label--none': !_vm.hasLabel,
      'input-group__label--right': _vm.labelPosition === 'right',
      'input-group__label--left': _vm.labelPosition === 'left',
     },attrs:{"for":_vm.id,"data-cy":_vm.dataCy},on:{"click":_vm.onClick}},[_c('input',{ref:"checkbox",staticClass:"input-group__input",attrs:{"id":_vm.id,"name":_vm.name,"disabled":_vm.disabled,"required":_vm.required,"type":"checkbox"},domProps:{"value":_vm.value,"checked":_vm.checked},on:{"change":_vm.onChange}}),_c('span',{staticClass:"check-indicator"}),(_vm.label)?_c('span',[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }